export const EXAMPLE_EVENTS = [
  { id: "ex-ev-1", date: "2026-08-23", name: "Course sur route — EXEMPLE", location: "Lieu à confirmer", category: "Course sur route", team: "masculine", status: "À venir" },
  { id: "ex-ev-2", date: "2026-09-06", name: "Challenge féminin — EXEMPLE", location: "Lieu à confirmer", category: "Course sur route", team: "feminine", status: "À venir" },
  { id: "ex-ev-3", date: "2026-09-19", name: "Journée école de cyclisme — EXEMPLE", location: "Le Boulou", category: "Événement club", team: "jeunes", status: "À venir" },
];

export const EXAMPLE_RESULTS = [
  { id: "ex-re-1", competition: "Grand Prix — EXEMPLE", date: "2026-07-05", location: "Lieu à confirmer", rider: "Coureur Exemple", team: "masculine", position: "—", result: "Résultat à venir" },
  { id: "ex-re-2", competition: "Circuit féminin — EXEMPLE", date: "2026-06-21", location: "Lieu à confirmer", rider: "Coureuse Exemple", team: "feminine", position: "—", result: "Résultat à venir" },
  { id: "ex-re-3", competition: "Course jeunes — EXEMPLE", date: "2026-06-07", location: "Lieu à confirmer", rider: "Jeune Exemple", team: "jeunes", position: "—", result: "Résultat à venir" },
];

export const EXAMPLE_ARTICLES = [
  {
    id: "ex-ar-1",
    slug: "exemple-1",
    title: "Bienvenue sur le nouveau site du club — EXEMPLE",
    category: "Club",
    date: "2026-07-01",
    author: "Club Cycliste Le Boulou",
    image: "",
    excerpt: "Cet article est un exemple de présentation. Les vraies actualités du club seront publiées ici.",
  },
  {
    id: "ex-ar-2",
    slug: "exemple-2",
    title: "Le cyclisme féminin, une ambition du club — EXEMPLE",
    category: "Cyclisme féminin",
    date: "2026-06-15",
    author: "Club Cycliste Le Boulou",
    image: "",
    excerpt: "Cet article est un exemple de présentation. Les vraies actualités du club seront publiées ici.",
  },
  {
    id: "ex-ar-3",
    slug: "exemple-3",
    title: "Cap sur le Sénégal — EXEMPLE",
    category: "Sénégal",
    date: "2026-06-01",
    author: "Club Cycliste Le Boulou",
    image: "",
    excerpt: "Cet article est un exemple de présentation. Les vraies actualités du club seront publiées ici.",
  },
];

export const EXAMPLE_PARTNERS = [
  "Partenaire Exemple 01",
  "Partenaire Exemple 02",
  "Partenaire Exemple 03",
  "Partenaire Exemple 04",
  "Partenaire Exemple 05",
  "Partenaire Exemple 06",
];
